export function getCookie(name: string) {
    const cookie = document.cookie;
    const allCookies = cookie.split(";");
    const searchName = `${name}=`;
    for (let i = 0; i < allCookies.length; i++) {
        const cookie = allCookies[i];
        if (cookie.includes(searchName)) {
            return cookie.split("=")[1];
        }
    }
    return null;
}

export function getAbTestVariant(cookieName: string): string | undefined {
    try {
        const cookieValue = getCookie(cookieName);
        if (!cookieValue) {
            return undefined;
        }

        const encodedPayload = decodeURIComponent(cookieValue);
        const base64Payload = encodedPayload.replace(/-/g, "+").replace(/_/g, "/");
        const paddedPayload = base64Payload.padEnd(Math.ceil(base64Payload.length / 4) * 4, "=");
        const binaryPayload = atob(paddedPayload);
        const payloadBytes = Uint8Array.from(binaryPayload, (character) => character.charCodeAt(0));
        const payload = JSON.parse(new TextDecoder().decode(payloadBytes)) as { VariantName?: unknown };

        const variantName = payload.VariantName;
        if (typeof variantName !== "string" || !variantName) {
            return undefined;
        }

        const variantMarker = "Variant";
        const variantMarkerIndex = variantName.indexOf(variantMarker);
        return variantMarkerIndex >= 0
            ? variantName.slice(variantMarkerIndex + variantMarker.length) || variantName
            : variantName;
    } catch {
        return undefined;
    }
}

export function deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function setCookie(name: string, value: string, days: number) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}
